class TagsToArrayDirective
  constructor: ()->
    class TagsToArray    
      restrict: "A"
      require: "ngModel"
      link: (scope, element, attrs, $ctrl)->
        console.log 'f'
        # $ctrl.$parsers.push (val)->
        #   console.log val
          # return new Date()
        $ctrl.$formatters.push (val)-> 
          result = []
          if val
            val.forEach (tag)->
              if tag?.text
                result.push tag.text
              else
                result.push tag
          console.log result
          return result
          # if val        
          #   return new Date(val)          
          # return null
        
    return new TagsToArray()
angular = require('angular')
pkg = angular
  .module 'common.tags', []
  .directive "tagsToArray", TagsToArrayDirective
  
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/common/tags/index.coffee